exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-07e6a3b4] {\n  background: #ebeff3;\n  border-radius: 10px;\n}\n.color_config_header[data-v-07e6a3b4] {\n  background: #ebeff3;\n  margin: 0 1rem;\n  padding: 0.5rem;\n}\n.card-footer[data-v-07e6a3b4] {\n  background-color: #ebeff3;\n  border-radius: 10px;\n  padding-top: 0;\n}\n.table[data-v-07e6a3b4] {\n  background-color: #ebeff3;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07e6a3b4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/confidenceColors.vue
// module id = 1312
// module chunks = 2